import React, { useState, useEffect } from "react";
import "./CookieBanner.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const { t } = useTranslation("global");
  const navigate = useNavigate();

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem("cookiesAccepted");
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setIsVisible(false);
  };

  const handleNavigate = () => {
    navigate("/privacy");
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <p>
        {t("cookies.text")}{" "}
        <span
          style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
          onClick={handleNavigate}
        >
          {t("cookies.more")}
        </span>
      </p>
      <button onClick={handleAccept}>{t("cookies.accept")}</button>
    </div>
  );
};

export default CookieBanner;